import React, { Component, Fragment } from 'react'
import queryString from 'query-string';

import Header from '../../components/header'
import {StyledCG, StyledButton, StyledSmallButton} from "./StyledCG";
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Input from '../../components/input'
import ReactDOM from 'react-dom'
import Button from '../../components/button'
import Button2 from '../../components/button2'
import ButtonUnclickable from '../../components/buttonunclickable'
import facebook from '../../assets/images/fb.png'
import google from '../../assets/images/google.png'
import apple from '../../assets/images/apple.png'
import PopUpBoxOtp from '../../components/modalotp';
import axios from 'axios'
import Indonesia from '../../assets/images/Indonesia.png'
import Singapore from '../../assets/images/Singapore.png'
import Malaysia from '../../assets/images/Malaysia.png'
import { Colors, Fonts, Scale } from '../../themes';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import PopUpBoxHandler from '../../components/modalhandler';
import CgRegisterImg from '../../assets/images/cg-register-img.svg';

import Select, { components } from 'react-select'
import colors from '../../themes/Colors';
import Swal from 'sweetalert2'
import GoogleLogin from 'react-google-login';
import AppConfig from '../../config'
import { Link } from 'react-router-dom';

import { verifyPartnerToken, verifyToken } from '../../api/UserAPI'

import ProccessData from '../../lib/ProccessData'

const countryCodeData =[
  
  {
    id: 0,
    name : '+65',
    value: '+65',
    label: <Row style={{ width:'200px',display:'flex',justifyContent:'flex-start'}}><img style={{marginRight:'5px',marginLeft:'15px',maxHeight:"20px", width:"20px"}} src={Singapore} />+65 </Row>
  },{
    id: 1,
    name : '+62',
    value: '+62',
    label: <Row style={{ width:'200px', display:'flex',justifyContent:'flex-start'}}><img style={{marginRight:'5px',marginLeft:'15px',maxHeight:"20px", width:"20px"}} src={Indonesia} />+62 </Row>
  },
  
  {
    id: 2,
    name : '+60',
    value: '+60',
    label: <Row style={{ width:'200px',display:'flex',justifyContent:'flex-start'}}><img style={{marginRight:'5px',marginLeft:'15px',maxHeight:"20px", width:"20px"}} src={Malaysia}  />+60  </Row>
  },
]

const stylesCountryCode = {
  
  control: base => ({
    ...base,
    fontFamily: Fonts.FontRegular,
    fontColor: Colors.color,
    fontSize: '14px',
    fontWeight:'bold',
    padding:'0',margin:'0'
  }),
  menu: base => ({
    ...base,
    fontFamily: Fonts.FontRegular,
    padding:'0',margin:'0',
    fontColor: Colors.color,
    fontSize: '14px',
    fontWeight:'bold'
  })
};

const accountUrl = AppConfig.ACCOUNT_URL

const clientID = AppConfig.CLIENT_ID
const eye = <FontAwesomeIcon icon={faEye} />;

export class RegistrationCG extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
          credentialType: "USERNAME",
          satu:'',dua:'',tiga:'',empat:'',lima:'',enam:'',
          code:'',
          username:'',
          password :'',
          firstname: '',
          lastname:'',
          email:'',
          confirmPassword:'',
          phone:'',
          type: 'password',
          show: false, 
          showError:false,
          errorMessage:'',
          enableBtn:false,
          idTokenGoogle:'',
          countryCode:'',
          defaultCountryCode:'',
          masterPartnerUid: null,
          partnerToken: queryString.parse(this.props.location.search).partnerToken,
          isInvited: queryString.parse(this.props.location.search).invitationId || null,
          tokenAdmin: null
        }
      }
   handleHide = (e)=> {
    
     this.setState({show: false})
 } 

  componentDidMount() {
    const partnerToken = queryString.parse(this.props.location.search).partnerToken
    if (partnerToken) this.checkToken(partnerToken)  

    const tokenAdmin = queryString.parse(this.props.location.search).token
    if(tokenAdmin) this.tokenCheck(tokenAdmin)
  }

  tokenCheck = async (token) => {
    try {
      let resultCheck = {}
      resultCheck.payload = await verifyToken({ headers: {
        Authorization: `${token}`
      }})
      ProccessData(resultCheck  , 'check token')
      .then(res => {
          this.setState({uidAdmin: res?.data?.account?.uid})
      })
      .catch(err => {
        this.alertError(err)
      })
    } catch (e) {
      this.alertError(e)
    }
  }

  checkToken = async (token) => {
    try {
      let resultCheck = {}
      resultCheck.payload = await verifyPartnerToken({ headers: {
        Authorization: `bearer ${token}`
      }})
      ProccessData(resultCheck  , 'check partner token')
      .then(res => {
        console.log('res => ', res)
        this.setState({
          masterPartnerUid: res.data.account.uid
        })
      })
      .catch(err => {
        console.log('err => ', err)
        this.alertError(err)
      })
    } catch (e) {
      this.alertError(e)
    }
  }

  alertError = (text, exit = true) => {
    Swal.fire({
      title: 'Error!',
      text,
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      preConfirm: () => {
        console.log('exit => ', exit)
        if (exit) {
          this.props.history.replace('/')
        } else null
      },
    })
  }

 handleCountryCode =(e)=> {
  this.setState({countryCode:e.value}, ()=>{

    
    console.log('countryCode', this.state.countryCode )
  })
  
this.setState({defaultCountryCode:e.id})
}; 
 validatePass=()=>{
   if(this.state.password.length >5){
     this.setState({enableBtn:false})
   }
 }
 togglePasswordVisiblity = () => {
    if(this.state.passwordShown==false){

      this.setState({passwordShown :true});
      
      this.setState({type:'text'})

    }else{
      this.setState({type:'password'})
      this.setState({passwordShown :false});
      
    }
  };
    
  responseGoogleFail = ()=> {
    Swal.fire({
      title: 'Warning!',
      text: 'This website uses cookies to help ensure you receive an optimal experience. Please activate cookies.',
      icon: 'info',
      confirmButtonText: 'OK'
    })
    
  }
 responseGoogle = (response) => {
   this.setState({credentialType: "GOOGLE"})
Swal.fire({
  title: 'Please fill username and phone number',
  html:
    `<label>username </label><input   id="swal-input1" class="swal2-input">` +
    `<label>phone </label><input   id="swal-input2" class="swal2-input">`,
    
    showCancelButton: true,
  preConfirm: () => {
    
      this.setState({username : document.getElementById('swal-input1').value})
     
     this.setState({phone :document.getElementById('swal-input2').value})
     if(this.state.username =='' ||this.state.phone=='') {
      Swal.fire({ title: 'Warning!',
      text: 'Username or phone cannot be empty',
      icon: 'info',
      confirmButtonText: 'OK'})
    }else{
      axios.post(`${accountUrl}/public/credential/checkCaregiverRegistration`, {
        username : this.state.username,
        phone: this.state.phone
   })
   .then(res => {
       console.log(res)
     if(res.status==200 && res.data.data.registered==true){
       
      Swal.fire({
        title: 'Warning!',
        text: 'This google account is already exist',
        icon: 'info',
        confirmButtonText: 'OK'
      })
     }else{ 
       this.setState({idTokenGoogle:response.tokenId, firstname: response.profileObj.givenName,
          lastname:response.profileObj.familyName,email:response.profileObj.email})

      this.submitForm(); 
      
     }
     
    })
  }


  }
})
 
    
  
  console.log(response);
}
  onChangeText = (stateName, value) => {
    this.setState({ [stateName]: value }
  //     , () => {
      // if((this.state.password.length >5) &&(this.state.password == this.state.confirmPassword)){

            //  this.setState({enableBtn:false})
      
    //  } else{
    //    this.setState({enableBtn:true})
    //  };
    // }
    );
  };
  onChangeOTP = (stateName, value)=>{
    let go =false
    if (value.length <= 1) {
      this.setState({[stateName]: value})
    }
    if (value.length === 1) {
      this.input2.focus();
    }
    if(this.input2.value.length==1){
      this.input3.focus();
    }
    if(this.input3.value.length==1){
      this.input4.focus();
    }
    if(this.input4.value.length==1){
      this.input5.focus();
    }
    if(this.input5.value.length==1){
      this.input6.focus();
    }
    
  }

  submitForm = () => { 

    console.log(this.state.countryCode.concat(this.state.phone))
    const isPartner = queryString.parse(this.props.location.search).partnerToken
    window.sessionStorage.setItem("isInvited", this.state.isInvited);
    axios.post(`${accountUrl}/public/credential/checkCaregiverRegistration`, {
      username : this.state.username,
      // phone: this.state.countryCode.concat(this.state.phone)
    })
    .then(res => {
     console.log(res.data)
    if(res.status==200 && res.data.data.registered==true){
     
      Swal.fire({
        title: 'Warning!',
        text: 'This username already exists',
        icon: 'info',
        confirmButtonText: 'OK'
      })
    } else {
      if (isPartner) {
        window.sessionStorage.setItem("firstname", this.state.firstname);
        window.sessionStorage.setItem("lastname", this.state.lastname);
        window.sessionStorage.setItem("email",this.state.email);
        window.sessionStorage.setItem("countryCode",this.state.countryCode);
        if (this.state.masterPartnerUid) window.sessionStorage.setItem("masterPartnerUid",this.state.masterPartnerUid);
        if (this.state.partnerToken) window.sessionStorage.setItem("partnerToken",this.state.partnerToken);
        this.props.history.push({pathname:'/CareGiverPersonDetail',
        state:{
          username: this.state.username,
          password: this.state.password,
          phone: this.state.phone,
          credentialType: this.state.credentialType,
          idTokenGoogle:this.state.idTokenGoogle,
          masterPartnerUid: this.state.masterPartnerUid,
          partnerToken: this.state.partnerToken,
          countryCode: this.state.countryCode,
        }})
      } else {
        axios.post(`${accountUrl}/public/credential/generateCaregiverSignUpOTP`, {
          phone : this.state.phone,
          prefixCountryNum: this.state.countryCode,
          channel: "sms",
          username: this.state.username
        })
        .then(res => {
          console.log(res)
           if(res.status==200 && res.data.type=="SUCCESS"){
            this.setState({show: true})
               console.log(res.data.data.otp)
        
          } else{
           
            Swal.fire({
              title: 'Warning!',
              text: `${res.data.data.message}`,
              icon: 'info',
              confirmButtonText: 'OK'
            }) 
          };
        }, (error) => {
          console.log(error);
        });
      }
   };
  })}

  handleNext = () => {
    this.props.history.push({
      pathname: '/registrationCG/first',
      state: {
        uidAdmin:this.state.uidAdmin
      }
    })
  }
    
    
  handleClose = () => {
    axios.post(`${accountUrl}/public/credential/verifyCaregiverSignUpOTP`, {
      phone : this.state.phone,
      prefixCountryNum: this.state.countryCode,
      code: `${this.state.satu}${this.state.dua}${this.state.tiga}${this.state.empat}${this.state.lima}${this.state.enam}`
      })
      .then(res => {
       
        console.log(res)
        if(res.status==200 && (res.data.data.valid.status=='approved' || res.data.data.valid.valid) ){
         
  this.setState({show: false})
  
  window.sessionStorage.setItem("firstname", this.state.firstname);
  window.sessionStorage.setItem("lastname", this.state.lastname);
  window.sessionStorage.setItem("email",this.state.email);
  window.sessionStorage.setItem("countryCode",this.state.countryCode);
  if (this.state.masterPartnerUid) window.sessionStorage.setItem("masterPartnerUid",this.state.masterPartnerUid);
  if (this.state.partnerToken) window.sessionStorage.setItem("partnerToken",this.state.partnerToken);
  this.props.history.push({pathname:'/CareGiverPersonDetail',
  state:{
    username: this.state.username,
    password: this.state.password,
    phone: this.state.phone,
    credentialType: this.state.credentialType,
    idTokenGoogle:this.state.idTokenGoogle,
    masterPartnerUid: this.state.masterPartnerUid,
    partnerToken: this.state.partnerToken,
    countryCode: this.state.countryCode,
  }})
  console.log(this.state.username)
  console.log(this.state.password)
  console.log(this.state.credentialType)

        if (this.state.password == this.state.confirmPassword) {
          console.log("Password Match")
        }
        return this.state
      } else {
        Swal.fire({
          title: 'Warning!',
          text: ` OTP CODE IS NOT VALID`,
          icon: 'info',
          confirmButtonText: 'OK'
        }) 
      };
    }, (error) => {
      console.log(error);
    });  
  }
    handleCloseError =()=>{
      this.setState({showError:false})
    }
    back=()=>{
      this.props.history.goBack()
    }

  render() {
      const {type,username,password,phone,confirmPassword,enableBtn,showError,errorMessage} = this.state
      const isPartner = queryString.parse(this.props.location.search).partnerToken
      console.log('this.state.invitationId => ', this.state.isInvited)
    return (
      <>
        <StyledCG>
          
        <Header title={isPartner ? ` ` : null} />
          <Row>
            <Col md={9}>
              <h2 style={{marginTop:'5%'}}>{isPartner ? `Create Organisation Staff Account` : `Steps to register`}</h2> 
            </Col>
            <Col md={3} className="d-flex justify-content-end align-items-center">
              <ButtonUnclickable disabled={false} buttonStyle={{ paddingLeft: 20, paddingRight: 20 }} text="I’m a Caregiver" backgroundColor={Colors.color14} />
            </Col>
          </Row>   
          {isPartner ? (
            <Fragment>
              <Row style={{textAlign:'start',marginTop:'6%'}}>
            <Col md={6} style={{margin:'auto'}}>
                <label>Username</label>
            </Col>
            <Col md={6} style={{margin:'auto'}}>
              <Input containerStyle="InputStyle" inputProps={{
                placeholder:'Type your username name here... ', 
                name:"username", 
                type:'text',
                value:username,
                onChange: (e) => this.onChangeText('username', e.target.value),}} 
              />
            </Col>
          </Row>
          <Row>
            <Col style={{margin:'auto'}}>
                <label>Password</label>
            </Col>
            <Col md={6}>              
            <Input containerStyle="InputStyle" inputProps={{
              placeholder:' Type your password here...',
              name:"password",
              type:type,
              value:password,
              onChange: (e) => this.onChangeText('password', e.target.value)}} />
              <i onClick={this.togglePasswordVisiblity}>{eye}</i>
            </Col>
          </Row>
          <Row>
            <Col style={{margin:'auto'}}>
              <label>Confirm Password</label>
            </Col>
            <Col md={6} > 
            <Input containerStyle="InputStyle" inputProps={{ 
              placeholder:' Type your confirm password here... ',
              name:"confirmPassword",
              type:type,
              value:confirmPassword,
              onChange: (e) => this.onChangeText('confirmPassword', e.target.value)}}  
            />
              <i onClick={this.togglePasswordVisiblity}>{eye}</i>
            </Col>
          </Row>
          <Row>
            <Col style={{margin:'auto'}}>
              <label>Mobile Number (Optional)</label>
            </Col>
            <Col md={2} style={{margin:'auto'}} >
              <Select placeholder='Country Code' className="select"  onChange={(e) =>  this.handleCountryCode(e)} styles={stylesCountryCode} defaultValue={countryCodeData[window.sessionStorage.getItem("defaultCountryCode")] } options={countryCodeData} />
            </Col>
            <Col md={4} style={{margin:'auto',padding:'0'}}>
              <Input containerStyle="InputStyle"  inputProps={{
                placeholder:' Type your phone here...',
                name:"phone",
                value:phone,
                onChange: (e) => this.onChangeText('phone', `${(e.target.value).replace(/[^0-9]/g, '')}`)}}  
              />
            </Col>
          </Row>
          <Row style={{justifyContent:'flex-end',marginRight:'1%',marginTop:'10%'}}>
            <Col md={3}>
              <Button onClick={this.back} containerStyle={StyledButton} textStyle={StyledButton} buttonStyle={{height:'50px',width:'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-end'}} backgroundColor={colors.color3} textColor={colors.color11} bordered={colors.color11} text="Back" />
            </Col>
            <Col md={3}>
              <Button disabled={enableBtn} buttonStyle={{height:'50px',width:'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-end'}} containerStyle={StyledButton} textStyle={StyledButton} text="Register" onClick={this.submitForm}/>
            </Col>
          </Row>
          <PopUpBoxOtp 
            close={this.handleHide} 
            prefix={this.state.countryCode} 
            lastDigit={this.state.phone.slice(7)} 
            show={this.state.show}  
            first={<input ref= {(input) => this.input1 = input} 
            selectTextOnFocus={true} 
            maxLength='1' 
            style={{ width:'50px',height:'50px',border:'1px solid #B1C2D8',borderRadius:'10px',textAlign:'center',outline: 'none',cursor:  'pointer', fontFamily: 'NunitoSans',fontWeight: 'bold',color: '#000000',resize: 'none', fontSize: '18px'}} 
            type='text' 
            value={this.state.satu} 
            onChange={(e) => this.onChangeOTP('satu', e.target.value)}/> } 
            second={<input ref= {(input) => this.input2 = input}   
            selectTextOnFocus={true} 
            maxLength='1'  
            style={{width:'50px',height:'50px',border:'1px solid #B1C2D8',borderRadius:'10px',textAlign:'center',outline: 'none',cursor:  'pointer', fontFamily: 'NunitoSans',fontWeight: 'bold',color: '#000000',resize: 'none', fontSize: '18px'}} 
            type='text' 
            value={this.state.dua} 
            onChange={(e) => this.onChangeOTP('dua', e.target.value)}/>} 
            third={<input  ref= {(input) => this.input3 = input} 
            selectTextOnFocus={true}  
            maxLength='1'  
            style={{width:'50px',height:'50px',border:'1px solid #B1C2D8',borderRadius:'10px',textAlign:'center',outline: 'none',cursor:  'pointer', fontFamily: 'NunitoSans',fontWeight: 'bold',color: '#000000',resize: 'none', fontSize: '18px'}} 
            type='text' 
            value={this.state.tiga} 
            onChange={(e) => this.onChangeOTP('tiga', e.target.value)}/>}
            fourth={<input  ref= {(input) => this.input4 = input}  
            selectTextOnFocus={true} 
            maxLength='1'  
            style={{width:'50px',height:'50px',border:'1px solid #B1C2D8',borderRadius:'10px',textAlign:'center',outline: 'none',cursor:  'pointer', fontFamily: 'NunitoSans',fontWeight: 'bold',color: '#000000',resize: 'none', fontSize: '18px'}} 
            type='text' 
            value={this.state.empat} 
            onChange={(e) => this.onChangeOTP('empat', e.target.value)}/>} 
            fifth={ <input  ref= {(input) => this.input5 = input}  
            selectTextOnFocus={true}
            maxLength='1'  
            style={{width:'50px',height:'50px',border:'1px solid #B1C2D8',borderRadius:'10px',textAlign:'center',outline: 'none',cursor:  'pointer', fontFamily: 'NunitoSans',fontWeight: 'bold',color: '#000000',resize: 'none', fontSize: '18px'}} 
            type='text' 
            value={this.state.lima} 
            onChange={(e) => this.onChangeOTP('lima', e.target.value)}/>} 
            sixth={<input  ref= {(input) => this.input6 = input}  
            selectTextOnFocus={true} 
            maxLength='1'  
            style={{width:'50px',height:'50px',border:'1px solid #B1C2D8',borderRadius:'10px',textAlign:'center',outline: 'none',cursor:  'pointer', fontFamily: 'NunitoSans',fontWeight: 'bold',color: '#000000',resize: 'none', fontSize: '18px'}} 
            type='text' 
            value={this.state.enam} 
            onChange={(e) => this.onChangeOTP('enam', e.target.value)}/>}
            size="modal-160w" 
            handleClose={this.handleClose} 
          />
          <PopUpBoxHandler show={showError} text={errorMessage} handleClose={this.handleCloseError}/>

          <Row style={{float:'right',marginTop:'15px'}}> 
              <a style={{marginRight: '10px'}} href="https://cara.sg/privacy-policy/"><p >Privacy Policy</p></a>. 
              <a style={{marginLeft: '10px',marginRight: '20px'}} href='https://cara.sg/terms-of-use/'>
                <p>Terms of Use</p>
              </a>
              
          </Row>
          <hr style={{marginTop:'110px',border: "1px solid #758BA9"}}/>
          {/* {
            !isPartner &&
              <Row style={{marginBottom:'50px'}}>
                <Col md={4}><a href=""><label className="signUp" >Or sign up with </label></a></Col>
                <Col md={8} style={{textAlign:'end'}}>  
                  <GoogleLogin
                    clientId={AppConfig.APP_CLIENT_ID}
                    render={renderProps => ( 
                      <button onClick={renderProps.onClick} disabled={renderProps.disabled}      className="google"><img style={{margin:'auto'}} src={google}/></button>
                    )}
                    onSuccess={this.responseGoogle}
                    onFailure={this.responseGoogleFail}
                    cookiePolicy={'single_host_origin'}
                  />                  
                </Col>
              </Row>
          } */}
            </Fragment>
          ) : (
            <Fragment>
              <Row className="justify-content-center mt-5">
                <Col md={11}>
                  <img src={CgRegisterImg} alt="Logo" />
                </Col>
              </Row>
              <Row className="justify-content-end my-5">
                <Col md={3}>
                  <Button disabled={false} buttonStyle={{height:'50px',width:'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-end'}} containerStyle={StyledButton} textStyle={StyledButton} text="Next" onClick={this.handleNext}/>
                </Col>
              </Row>
            </Fragment>
          )}
        </StyledCG>       
      </>
    )
  }
}


export default RegistrationCG